module.exports = __webpack_public_path__ + "img/platformLogo.b1766f32.png";